import Layout from "@/layout/Container.vue"
import { clear, getStorage } from "../storage"
import router from "@/router"
import Router from "vue-router"

export const commonRouter = [
  {
    path: '/',
    redirect: '/home/index'
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: "登录",
    },
    component: () => import("@/views/login/index")
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: ""
    },
    component: Layout,
    children: [
      {
        path: '/home/index',
        name: 'HomeIndex',
        meta: {
          title: '工作台',
        },
        component: () => import("@/views/home/index")
      },
      {
        path: '/home/payslipTip',
        name: 'HomePayslipTip',
        meta: {
          title: '待办消息',
        },
        component: () => import("@/views/home/payslipTip")
      },
      {
        path: '/home/Login',
        name: 'HomeLogin',
        meta: {
          title: '全部消息',
        },
        component: () => import("@/views/Login")
      },
      {
        path: '/home/Home',
        name: 'HomeHome',
        meta: {
          title: '全部消息',
        },
        component: () => import("@/views/Home")
      },
      {
        path: '/personnel/build',
        name: 'organizeBuild',
        meta: {
          title: '架构图',
        },
        component: () => import("@/views/personnel/organize/build.vue")
      },
      {
        path: '/test/websocket-test',
        name: 'websocket',
        meta: {
          title: "socket测试",
        },
        component: () => import("@/views/test/websocket-test.vue")
      },
      {
        path: '/financial/cost',
        name: 'financialcost',
        meta: {
          title: "费用类型",
        },
        component: () => import("@/views/financial/cost/index.vue")
      },
    ]
  },
  {
    path: '*',
    name: '404',
    meta: {
      title: '404',
    },
    component: () => import("@/views/404")
  },
]
function importComponent(arr) {
  arr.forEach(item => {
    if (!!item.children) {
      item.component = Layout
      if (!!item.children.length) {
        item.redirect = item.children[0].path
        importComponent(item.children)
      }
    } else {
      item.component = () => import(`@/views${item.path}`)
    }
  });
}


//生成动态路由
export function initRouter() {
  const roleRouter = getStorage("router")
  if (roleRouter) {
    console.log(roleRouter,'roleRouterroleRouter')
    importComponent(roleRouter)
    commonRouter.splice(3, 0, ...roleRouter)
    router.matcher = new Router({
      mode: 'history',
      routes: commonRouter,
    }).matcher
  } else {
    clear()
    router.replace("/login")
  }
}